<template>
  <div>
    <el-form ref="form" onsubmit="return false" :inline="true" :model="filter" style="text-align: left">
      <template v-for="(item, index) in filterConfig">
        <el-form-item
                :key="index"
                :label="item.label"
                v-if="!item.hide"
                :label-width="item.labelWidth ? item.labelWidth + 'px' : '100px'"
        >
          <el-input
                  v-if="item.type === 'input' && !item.isTemplate"
                  v-model="filter[item.prop]"
                  placeholder=""
          ></el-input>
          <el-date-picker
                  v-if="item.type === 'datetime' && !item.isTemplate"
                  v-model="filter[item.prop]"
                  style="width: 250px"
                  type="daterange"
                  value-format="timestamp"
                  :default-time="['00:00:00', '23:59:59']"
                  :append-to-body="true"
          />

          <el-date-picker
                  v-if="item.type === 'datetimeSingle' && !item.isTemplate"
                  v-model="filter[item.prop]"
                  style="width: 300px"
                  type="datetimerange"
                  @change="item.change"
                  value-format="timestamp"
                  :default-time="['00:00:00', '23:59:59']"

                  :picker-options = "item.pickerOptions"
                  :append-to-body="true"
          />

          <el-date-picker
            v-model="filter[item.prop]"
            class="singleDate"
            v-if="item.type == 'singleDate' && !item.isTemplate"
            type="date"
            value-format="timestamp"
            :append-to-body="true"
           >
          </el-date-picker>

          <template v-if="item.isTemplate" :slot-scope="filter">
            <slot :name="item.prop" :filter="filter"></slot>
          </template>
        </el-form-item>
      </template>

      <div class="btn-wrap">
        <button class="btn search-btn aa"  @click="handleSearch">
          {{$t('version23.search')}}
        </button>
        <button class="btn rest-btn aa" @click="handleRest">
          {{$t('pageTitle.chongzhi')}}
        </button>
        <button class="btn rest-btn export-btn aa" @click="exportData" v-if="exportBtn">
          {{$t('version23.exportBtn')}}
        </button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import {exportBlob} from "../request/api";

  export default {
  props: {
    exportBtn : {
      type : Boolean,
      default : false
    },
    filterConfig: {
      type: Array,
      default: () => []
    },
    defaultFilter: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      filter: {},
      originFilter: {}
    }
  },
  created() {
    this.originFilter = {...this.defaultFilter} // 保存初始默认数据，当重置后好恢复
    this.filter = {...this.defaultFilter}
  },
  methods: {
    /**
     * 下载excel
     * @param {blob} fileArrayBuffer 文件流
     * @param {String} filename 文件名称
     */
    downloadXls(fileArrayBuffer, filename){
    let data = new Blob([fileArrayBuffer], {
      type: "application/vnd.ms-excel,charset=utf-8",
    });
    if (typeof window.chrome !== "undefined") {
      // Chrome
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(data);
      link.download = filename;
      link.click();
    } else if (typeof window.navigator.msSaveBlob !== "undefined") {
      // IE
      var blob = new Blob([data], { type: "application/force-download" });
      window.navigator.msSaveBlob(blob, filename);
    } else {
      // Firefox
      var file = new File([data], filename, {
        type: "application/force-download",
      });
      window.open(URL.createObjectURL(file));
    }
  },
    getTimeArr(data,desKey,key1,key2){
    console.log(data,'dfffffffffffff')
    if (undefined != data[desKey]) {
      let arr = [];
      if (!(data[desKey] instanceof Array)) {
        arr = data[desKey].split(",");
      } else {
        arr = data[desKey];
      }
      data[key1] = arr[0];
      data[key2] = arr[1];

      delete data[desKey];
    }
  },
    serialize(data){
      let list = [];
      Object.keys(data).forEach((ele) => {
        list.push(`${ele}=${data[ele]}`);
      });
      return list.join("&");
    },
      exportData(){
      let filter = {}
      for(var i in this.filter){
        if(this.filter[i]!==undefined && this.filter[i]!==null
        && this.filter[i]!=='')
          filter[i] = this.filter[i]
      }


        let path = this.$route.fullPath,url,nameMap;
        switch (path) {
          case '/myTeam':
            nameMap = 'myTeams'
            url = '/api/rocket-api/invite/report/my/team/outExcel'
            this.getTimeArr(filter,'regtime','startRegisterTime','endRegisterTime')
            this.getTimeArr(filter,'logintime','startLoginTime','endLoginTime')
            let r = this.transDateTypeToTimeStamp(filter.dataTimeVal);
            filter.dataStartTime = r[0];
            filter.dataEndTime = r[1];
            break;
        }

        for (let key in filter) {
          if (Array.isArray(filter[key]) && filter[key].length === 2 && String(filter[key][1]).slice(8) === '99000') {
            filter[key][1]+=999
          }
        }
        console.log(filter,'filter')
        let str = this.serialize(filter)

      exportBlob(
              url + '?'+ str
      ).then((res) => {

        this.downloadXls(res.data,`${nameMap}.xlsx`);
        // NProgress.done();
      });
    },
    handleSearch() {
      for (let key in this.filter) {
        if (Array.isArray(this.filter[key]) && this.filter[key].length === 2 && String(this.filter[key][1]).slice(8) === '99000') {
          this.filter[key][1]+=999
        }
      }
      this.$emit('filterSearch', this.filter)
    },
    handleRest() {
      this.filter = {...this.originFilter}
      this.$emit('filterRest', this.filter)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-form-item {
  height: 34px;
  margin-bottom: 34px;
  /deep/.el-form-item__label {
    height: 34px;
    color: rgba(255, 255, 255, 1);
    line-height: 34px;
    word-break: keep-all;
    /*overflow: hidden;*/
  }
  /deep/.el-form-item__content {
    height: 34px;
    line-height: 34px;
    /deep/.el-input {
      height: 34px;
    }
    /deep/.el-input__inner {
      -webkit-appearance: none;
      height: 34px;
      border: none;
      font-size: 12px;
      line-height: 17px;
      padding: 7px 10px;
      color: rgba(255, 255, 255, 1);
      background-color: rgba(38, 39, 42, 1);
    }
   
    .el-input__suffix {
      .el-input__suffix-inner {
        .el-select__caret {
          line-height: 34px;
          color: rgba(255, 255, 255, 1);
        }
      }
    }

    .el-input__icon {
      line-height: 34px;
      /*display: none;*/
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .el-range-input {
      background-color: rgba(38, 39, 42, 1);
    }
    .el-range-separator {
      line-height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
/deep/.singleDate .el-input__inner{
      padding-left : 30px !important;
    }
/deep/.el-picker-panel {
  top: 28px !important;
  border: none;
  background-color: rgba(28, 29, 32, 1);
  .el-picker-panel__icon-btn:hover {
    color: #eac83e;
  }
  .el-date-range-picker__content {
    .el-date-table__row {
      .available {
        color: white;
      }
      .in-range {
        div {
          background-color: #26272a;
        }

      }
      .start-date {
        span {
          background-color: #eac83e;
          color: white !important;
        }
      }
      .end-date {
        span {
          background-color: #eac83e;
          color: white !important;
        }
      }
      .today {
        span {
          color: #eac83e;
        }
      }
      .prev-month {
        color:#606266;
      }
      .next-month {
        color:#606266;
      }
    }
  }
  .is-left {
    border-right: 1px solid #606266;
  }
  .el-date-table th {
    border-bottom: 1px solid #606266;
  }
  .popper__arrow {
    display: none !important;
  }
}

/deep/.el-select-dropdown {
  background-color: rgba(28, 29, 32, 1);
  border: none;
  top: 28px !important;
  left: 0 !important;
  .el-scrollbar {
    background-color: rgba(28, 29, 32, 1) !important;
    .el-select-dropdown__list {
      max-height: 200px;
      .el-select-dropdown__item {
        text-align: left;
        &:hover {
          background-color: rgba(44, 44, 44, 1);
        }
      }
      .selected {
        color: rgba(234, 200, 62, 1);
      }
      .hover {
        background-color: rgba(28, 29, 32, 1);
      }
    }
    .el-scrollbar__bar {
      width: 4px;
      .el-scrollbar__thumb {
        background-color: rgba(255, 255, 255, 1);
      }
    }
  }
  .popper__arrow {
    display: none !important;
  }
}

  .btn-wrap {
    display: inline-block;
    margin-bottom: 15px;
    .btn {
      border-radius: 2px;
      height: 34px;
      width: 80px;
      border: none;
      cursor: pointer;
    }
    .search-btn {
      color: rgba(51, 51, 51, 1);
      background-color: rgba(234, 200, 62, 1);
      margin-right: 10px;
      &:active{
        background: #f5a533;
      }
    }
    .rest-btn {
      border: 1px solid rgba(234, 200, 62, 1);
      color: rgba(234, 200, 62, 1);
      background-color: rgba(22, 22, 24, 1);
      &:active{
        border : 1px solid #f5a533;
        color : #f5a533;
      }
    }
    .export-btn{
      margin-left: 10px;
      &:active{
        border : 1px solid #f5a533;
        color : #f5a533;
      }
    }
  }
</style>

<style lang="scss">
  .el-form-item {
    height: 34px;
    margin-bottom: 34px;
    .el-form-item__label {
      height: 34px;
      color: rgba(255, 255, 255, 1);
      line-height: 34px;
      word-break: keep-all;
      /*overflow: hidden;*/
    }
    .el-form-item__content {
      height: 34px;
      line-height: 34px;
      .el-input {
        height: 34px;
      }
      .el-input__inner {
        -webkit-appearance: none;
        height: 34px;
        border: none;
        font-size: 12px;
        line-height: 17px;
        padding: 7px 10px;
        color: rgba(255, 255, 255, 1);
        background-color: rgba(38, 39, 42, 1);
      }
      .el-input__suffix {
        .el-input__suffix-inner {
          .el-select__caret {
            line-height: 34px;
            color: rgba(255, 255, 255, 1);
          }
        }
      }

      .el-input__icon {
        line-height: 34px;
        /*display: none;*/
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .el-range-input {
        background-color: rgba(38, 39, 42, 1);
        color: white;
      }
      .el-range-separator {
        line-height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .el-picker-panel {
    /*top: 28px !important;*/
    border: none;
    background-color: rgba(28, 29, 32, 1);
    .el-picker-panel__icon-btn:hover {
      color: #eac83e;
    }
    .el-date-range-picker__content {
      .el-date-table__row {
        .available {
          color: white;
        }
        .in-range {
          div {
            background-color: #26272a;
          }

        }
        .start-date {
          span {
            background-color: #eac83e;
            color: white !important;
          }
        }
        .end-date {
          span {
            background-color: #eac83e;
            color: white !important;
          }
        }
        .today {
          span {
            color: #eac83e;
          }
        }
        .prev-month {
          color:#606266;
        }
        .next-month {
          color:#606266;
        }
      }
    }
    .is-left {
      border-right: 1px solid #606266;
    }
    .el-date-table th {
      border-bottom: 1px solid #606266;
    }
    .popper__arrow {
      display: none !important;
    }
  }

  .el-select-dropdown {
    background-color: rgba(28, 29, 32, 1);
    border: none;
    /*top: 28px !important;*/
    /*left: 0 !important;*/
    .el-scrollbar {
      background-color: rgba(28, 29, 32, 1) !important;
      .el-select-dropdown__list {
        max-height: 200px;
        .el-select-dropdown__item {
          text-align: left;
          &:hover {
            background-color: rgba(44, 44, 44, 1);
          }
        }
        .selected {
          color: rgba(234, 200, 62, 1);
        }
        .hover {
          background-color: rgba(28, 29, 32, 1);
        }
      }
      .el-scrollbar__bar {
        width: 4px;
        .el-scrollbar__thumb {
          background-color: rgba(255, 255, 255, 1);
        }
      }
    }
    .popper__arrow {
      display: none !important;
    }
  }
</style>
